import QK from '@opsbase/lib-data-queryfield/QueryFieldKey';
import DataType from '@opsbase/lib-datatype/DataType/DataType';
import Event from '@opsbase/lib-event';
import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import App from '@opsbase/lib-system/App/App';
import Features from '@opsbase/lib-system/Features/Features';
import OperatorType from '@opsbase/lib-workflow/WorkflowCondition/OperatorType';
import useSelfActions from '@opsbase/react-ctrl-self/useSelfActions/useSelfActions';
import useAssetFindById from '@opsbase/react-gql-hooks/asset/useAssetFindById';
import useAssetUpdate from '@opsbase/react-gql-hooks/asset/useAssetUpdate';
import useWorkflows from '@opsbase/react-gql-hooks/workflow/useWorkflows';
import useCss from '@opsbase/web-css';
import useNewDataActions from '@opsbase/web-ctrl-newdata/useNewDataActions';
import Dialog from '@opsbase/web-dialogs/Dialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import useParams from '@opsbase/web-nav/useParams';
import Tab from '@opsbase/web-tabs/Tab';
import Tabs from '@opsbase/web-tabs/Tabs';
import React, { useCallback, useState } from 'react';
import AssetEditOverviewSection from './AssetEditOverviewSection';
import AssetEditSensorTab from './AssetEditSensorTab';
import AssetEditWorkflowTab from './AssetEditWorkflowTab';
const makeMyClasses = () => ({
    leftPane: {
        width: 300,
        marginRight: 12,
    },
    sensorPane: {
        backgroundColor: Palette.WhiteSmoke.main,
        border: `1px solid ${Palette.BorderGrey.main}`,
    },
});
const styles = {
    width: 18,
    height: 18,
    marginRight: 2,
    color: 'white',
    lineHeight: '18px',
    fontSize: 10,
    textAlign: 'center',
    borderRadius: '50%',
    backgroundColor: Palette.GoodOldBlue.main,
};
export function AssetEditDialog() {
    const { id } = useParams();
    const { hasFeature } = useSelfActions();
    const [selectedTab, setSelectedTab] = useState(0);
    const { loading, data: asset } = useAssetFindById({ variables: { id } });
    const updateAsset = useAssetUpdate();
    const { updateItemsForType } = useNewDataActions();
    const myCss = useCss(makeMyClasses);
    const { data: workflows } = useWorkflows({
        variables: {
            workflowEvent: [Event.SENSOR_READING],
            condition: [QK.ASSET + '_#' + OperatorType.EQUAL + '_#' + (asset === null || asset === void 0 ? void 0 : asset.id)],
        },
    });
    const hasIoT = hasFeature(Features[App.OPSBASE].INTEGRATIONS_IOT.key);
    const handleChangeTitle = useCallback(title => {
        if (!title)
            return;
        updateAsset({ id, patch: { title } })
            .then(a => updateItemsForType(DataType.ASSET, [a]))
            .catch(doNothing);
    }, [id, updateAsset, updateItemsForType]);
    const handleChangeSelectedTab = useCallback((e, v) => {
        setSelectedTab(v);
    }, []);
    return (React.createElement(Dialog, { editableTitle: true, size: DialogSize.XFULL_YFULL, padded: false, white: true, loading: loading, title: asset ? asset.title : '', onChangeTitle: handleChangeTitle }, asset && (React.createElement(Horizontal, { stretch: true },
        React.createElement(Pane, { classes: { root: myCss.leftPane } },
            React.createElement(AssetEditOverviewSection, { asset: asset })),
        hasIoT && (React.createElement(Vertical, { style: { overflow: 'hidden' } },
            React.createElement(Pane, { style: { paddingLeft: 16 } },
                React.createElement(Tabs, { value: selectedTab, onChange: handleChangeSelectedTab },
                    React.createElement(Tab, { label: i18n.t('sensor'), value: 0 }),
                    React.createElement(Tab, { label: React.createElement(Horizontal, { gutter: true },
                            React.createElement(Pane, null, i18n.t('workflows')),
                            (workflows === null || workflows === void 0 ? void 0 : workflows.length) && (React.createElement(Pane, { style: styles }, workflows === null || workflows === void 0 ? void 0 : workflows.length))), value: 1 }))),
            React.createElement(Pane, { grow: true, scroll: true, classes: { root: myCss.sensorPane } },
                selectedTab === 0 && React.createElement(AssetEditSensorTab, { asset: asset }),
                selectedTab === 1 && React.createElement(AssetEditWorkflowTab, { asset: asset })))),
        !hasIoT && (React.createElement(Vertical, { style: { overflow: 'hidden' } },
            React.createElement(Pane, { style: { paddingLeft: 16 } },
                React.createElement(Tabs, { value: 0 },
                    React.createElement(Tab, { label: React.createElement(Horizontal, { gutter: true },
                            React.createElement(Pane, null, i18n.t('workflows')),
                            (workflows === null || workflows === void 0 ? void 0 : workflows.length) && (React.createElement(Pane, { style: styles }, workflows === null || workflows === void 0 ? void 0 : workflows.length))), value: 0 }))),
            React.createElement(Pane, { grow: true, scroll: true, classes: { root: myCss.sensorPane } },
                React.createElement(AssetEditWorkflowTab, { asset: asset }))))))));
}
export default AssetEditDialog;
